<template>
  <b-modal :id="`LancamentoDetalhes`"
           :ref="`LancamentoDetalhes`"
           no-close-on-backdrop
           no-close-on-esc
           class="LancamentoDetalhes"
           header-class="LancamentoDetalhes_header"
           body-class="LancamentoDetalhes_body"
           content-class="LancamentoDetalhes_content"
           size="xl"
           visible>
    <template slot="modal-header">
      <div>
        <b class="ml-2">Detalhe Lançamento</b>
      </div>
    </template>

    <div class="row mb-3">
      <div class="col-3">
        <label class="label"
               for="">Data do Lançamento</label>
        <div>
          {{ propLancamento.data_lancamento | date }}
        </div>
      </div>
      <div class="col-4">
        <label class="label"
               for="">Tipo de Lançamento</label>
        <div>
          {{ propLancamento.tipo | firstCapitalize }}
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-3">
        <label class="label"
               for="">Categoria</label>
        <div>
          {{ propLancamento.categoria.nome }}
        </div>
      </div>
      <div class="col-4">
        <label class="label"
               for="">Beneficiário</label>
        <div>
          {{ propLancamento.fornecedor ? propLancamento.fornecedor.nome : 'Não informado' }}
        </div>
      </div>
      <div class="col-3">
        <label class="label"
               for="">Número de documento</label>
        <div>
          {{ propLancamento.numero_documento || 'Não informado' }}
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-3">
        <label class="label"
               for="">Quantidade</label>
        <div>
          {{ propLancamento.atos }}
        </div>
      </div>
      <div class="col-4">
        <label class="label"
               for="">Detalhamento</label>
        <div>
          {{ propLancamento.detalhamento }}
        </div>
      </div>
      <div class="col-3">
        <label class="label"
               for="">Valor</label>
        <div>
          {{ propLancamento.valor | moneyToString }}
        </div>
      </div>
    </div>
    <div v-if="propLancamento.livroCaixaLancamentoArquivo.length">
      <div v-if="!documentos || !documentos.length"
           class="row justify-content-center mt-4">
        <div class="col-12 d-flex justify-content-center">
          <b-spinner variant="primary" />
        </div>
        <div class="col-12 d-flex justify-content-center mt-2">
          <small>Carregando...</small>
        </div>
      </div>
      <div v-else
           class="row">
        <div class="col-3">
          <div class="MenuImagens">
            <div class="MenuImagens_header">
              Imagens
            </div>
            <div v-for="(documento, index) in documentos"
                 :key="index"
                 class="MenuImagens_imagem"
                 :class="{'MenuImagens_imagem_active': imageActive === index}"
                 @click="changePDF(documento, index)">
              Documento {{ index + 1 }}
            </div>
          </div>
        </div>
        <div class="col-9">
          <div class="Imagem">
            <object class="document-preview embed-responsive"
                    :data="urlPDF"
                    type="application/pdf">
              <p>Seu browser não suporta arquivos pdf diretamente ou este arquivo não existe. Você pode tentar efetuar o download clicando.</p>
            </object>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="propLancamento.tipo === 'DESPESA' "
         class="row">
      <div class="col-12">
        <b>
          Nenhum documento adicionado ao lançamento
        </b>
      </div>
    </div>

    <template slot="modal-footer">
      <button class="btn btn-sm btn-light px-3"
              @click="hide()">
        Voltar
      </button>
      <button class="btn btn-sm btn-primary"
              @click="editar()">
        Editar
      </button>
    </template>
  </b-modal>
</template>

<script>
  //Services
  import LivroCaixaService from "@/services/LivroCaixaService"

  export default {
    name: 'LancamentoDetalhes',
    props: {
      propLancamento: { type: Object, default: () => ({})}
    },
    data () {
      return {
        localData: {
          documento: {}
        },
        imageActive: 0,
        documentos: [],
        urlPDF: null
      }
    },
    mounted () {
      this.getDocumentos()
    },
    methods: {
      hide () {
        this.$emit('hide')
      },
      editar () {
        const ordemServicoId = this.propLancamento.ordemServicoItem ? this.propLancamento.ordemServicoItem.ordem_servico_id : this.propLancamento.ordem_servico_item_id
        
        if (ordemServicoId) {
          return this.$router.push(`/ordem-servico/${ordemServicoId}`)
        }

        this.$emit('editar', this.propLancamento)
      },
      async getDocumentos () {
        if (!this.propLancamento.livroCaixaLancamentoArquivo.length) return

        try {
          const documentos = await LivroCaixaService.getDocumentos(this.propLancamento.livro_caixa_lancamento_id)

          if (documentos && documentos.length) {
            const imagens = []

            for (const documento of documentos) {
              const res = await LivroCaixaService.getPDF(documento.url)

              if (res) {
                this.propLancamento.livroCaixaLancamentoArquivo.forEach(arq => {
                  if (arq.livro_caixa_lancamento_arquivo_id === documento.livro_caixa_lancamento_arquivo_id) {
                    arq.pdf = res
                  }
                })

                imagens.push(res)
              }
            }

            this.documentos = imagens

            this.changePDF(imagens[0], 0)

          }
        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        }
      },
      changePDF (documento, index) {
        let blob = new Blob([documento], { type: 'application/pdf' })
        let url = window.URL.createObjectURL(blob)
        this.urlPDF = url

        this.imageActive = index
      }
    }
  }
</script>

<style lang="scss">
  .LancamentoDetalhes {
    &_header {
      background: #074f7f;
      color: #fff;
      padding: 10px;
      font-size: 20px;
      font-weight: bold;
      border-radius: 0px;
    }

    &_content {
      border-radius: 0px;
    }

    &_body {
      padding: 20px;
    }

    &_body label {
      font-size: 16px;
      font-weight: 500;
      color: #000;
    }
  }

  .MenuImagens {
    border: 1px solid #000;

    &_header {
      background: #000;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      padding: 5px;
    }

    &_imagem {
      cursor: pointer;
      color: #000;
      font-size: 15px;
      padding: 5px;
      background: #fff;

      &_active {
        background: #086aae !important;
        color: #fff;
        transition: 0.2s;
      }
    }

    &_imagem:hover {
      background: #e2e2e2;
      transition: 0.2s;
    }
  }

  .Imagem {
    border: 1px solid black;
    width: 100%;
  }

  .document-preview {
    height: 500px !important;
  }
</style>
